import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { TextInput, CustomSelect, styleVariables } from '@lib/common';
import { Title } from '@module/form';
import { Form as FormInput, Select, Skeleton } from 'antd';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Option = Select.Option;
export var StyledRequiredMark = styled.span.withConfig({
  displayName: "editing-quiz-informationcomponent__StyledRequiredMark",
  componentId: "sc-1likk6v-0"
})(["color:", ";margin-left:4px;"], styleVariables.colors.red4);
export var EditingQuizInformationComponent = function EditingQuizInformationComponent(props) {
  var tags = props.tags,
      formCategories = props.formCategories,
      label = props.label,
      error = props.error,
      placeHolder = props.placeHolder,
      translation = props.translation;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormInput.Item, {
      noStyle: true,
      children: function children() {
        return formCategories ? /*#__PURE__*/_jsx(FormInput.Item, {
          label: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx("span", {
              children: label.formCategory
            }), /*#__PURE__*/_jsx(StyledRequiredMark, {
              children: "*"
            })]
          }),
          name: "category",
          children: /*#__PURE__*/_jsx(CustomSelect, {
            allowClear: true,
            size: "large",
            placement: "bottomLeft",
            placeholder: placeHolder.formCategory,
            showSearch: true,
            maxTagCount: "responsive",
            children: formCategories ? formCategories.map(function (category) {
              return /*#__PURE__*/_jsx(Option, {
                value: category.key,
                children: category.key
              }, category.id.toString());
            }) : /*#__PURE__*/_jsx(Skeleton.Input, {})
          })
        }) : /*#__PURE__*/_jsx(Skeleton.Input, {
          block: true,
          active: true
        });
      }
    }), /*#__PURE__*/_jsx(FormInput.Item, {
      label: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          children: label.title
        }), /*#__PURE__*/_jsx(StyledRequiredMark, {
          children: "*"
        })]
      }),
      rules: [{
        required: true,
        message: error.title
      }, {
        validator: function () {
          var _validator = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_rule, value) {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.prev = 0;

                    if (!Title.isValid(value)) {
                      _context.next = 5;
                      break;
                    }

                    return _context.abrupt("return", Promise.resolve());

                  case 5:
                    return _context.abrupt("return", Promise.reject(translation('InvalidTitleLengthError')));

                  case 6:
                    _context.next = 11;
                    break;

                  case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](0);
                    throw new Error('Title validate error');

                  case 11:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[0, 8]]);
          }));

          function validator(_x, _x2) {
            return _validator.apply(this, arguments);
          }

          return validator;
        }()
      }],
      name: "title",
      required: true,
      children: /*#__PURE__*/_jsx(TextInput, {
        size: "large",
        allowClear: true,
        placeholder: placeHolder.title,
        autoFocus: true
      })
    }), /*#__PURE__*/_jsx(FormInput.Item, {
      label: label.description,
      name: "description",
      children: /*#__PURE__*/_jsx(TextInput, {
        size: "large",
        placeholder: placeHolder.description
      })
    }), /*#__PURE__*/_jsx(FormInput.Item, {
      noStyle: true,
      children: function children() {
        return /*#__PURE__*/_jsx(FormInput.Item, {
          label: /*#__PURE__*/_jsx("span", {
            children: label.tag
          }),
          name: "tags",
          children: /*#__PURE__*/_jsx(CustomSelect, {
            mode: "tags",
            allowClear: true,
            size: "large",
            placement: "bottomLeft",
            placeholder: placeHolder.tag,
            showSearch: true,
            maxTagCount: "responsive",
            children: tags ? tags.map(function (tag) {
              return /*#__PURE__*/_jsx(Option, {
                value: tag.key,
                children: tag.key
              }, tag.id.toString());
            }) : /*#__PURE__*/_jsx(Skeleton.Input, {})
          })
        });
      }
    })]
  });
};